import type React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

export const PhoneImage: React.FC = () => {
	const { translate } = useI18n();

	return (
		<div className="relative top-6 -my-10 h-[211px] w-[217px] overflow-hidden">
			<picture>
				<source
					type="image/webp"
					srcSet="https://static.change.org/images/mobile-app-phone-mockup-1x.webp 1x, https://static.change.org/images/mobile-app-phone-mockup-2x.webp 2x"
				/>
				<img
					src="https://static.change.org/images/mobile-app-phone-mockup-1x.png"
					srcSet="https://static.change.org/images/mobile-app-phone-mockup-1x.png 1x, https://static.change.org/images/mobile-app-phone-mockup-2x.png 2x"
					alt={translate('corgi.app_download.bottom_banner_v2.phone_mockup.image_alt_text')}
				/>
			</picture>
		</div>
	);
};
